var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "next",
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000216202 8.31874C0.000216253 7.72874 0.470216 7.25874 1.06022 7.25874L16.5402 7.25874L11.7302 2.44874C11.3202 2.03874 11.3202 1.35874 11.7302 0.948737C11.9402 0.738737 12.2102 0.638738 12.4802 0.638738C12.7502 0.638738 13.0202 0.738737 13.2302 0.948737L19.8502 7.56874C20.2602 7.97874 20.2602 8.64874 19.8502 9.06874L13.2402 15.6887C12.8302 16.0987 12.1502 16.1087 11.7402 15.6887C11.3302 15.2787 11.3202 14.6087 11.7402 14.1887L16.5402 9.37874L1.06022 9.37874C0.470215 9.37874 0.000216151 8.89874 0.000216202 8.31874Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.d2d5c174ece06f72c54ba015ee587d75.svg";
export { ForwardRef as ReactComponent };